import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress } from '@material-ui/core'
import { Page, Header } from 'components'
import { Form } from './Form'
import { useEntregaCadaver } from './hooks/useEntregaCadaver'
import useStyles from './EntregaCadaver.styles'

export const EntregaCadaver = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    cadaver,
    processando,
  } = useEntregaCadaver()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      
      <div className={classes.formContainer}>
        {processando && !cadaver.id ? (
          <div className={classes.carregando}>
            <CircularProgress disableShrink />
          </div>
        ) : (
          /* Renderização direta do Formulário sem Card wrapper (Layout Flattening 🛸🚀) */
          cadaver.id && <Form cadaver={cadaver} />
        )}
      </div>
    </Page>
  )
}

EntregaCadaver.propTypes = {
  route: PropTypes.object.isRequired,
}
